import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-testimonials-custom',
    templateUrl: './pb-testimonials-custom.component.html',
    styleUrls: ['./pb-testimonials-custom.component.scss']
})
export class PbTestimonialsCustomComponent implements OnInit {

    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';

    quotes: any = [];
    isBeginWhy: boolean = true;
    isEndWhy: boolean = false;
    whySwiperInstance: any;

    constructor(private api: ApiService, private cd: ChangeDetectorRef) { }

    ngOnInit(): void {

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchQuotes();

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetches customer quotes
     */
    async fetchQuotes() {

        await this.api.fetch_quotes()
            .subscribe(res => {
                this.quotes = res.data.items;
                this.quotes.forEach((item, index) => {
                    this.quotes[index].quote = JSON.parse(item.quote); 
                });
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    /**
     * When 'Why people love IBTC' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onWhySwiper(swiper) {

        this.whySwiperInstance = swiper;

        setTimeout(() => {
            // swiper.update();
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onWhySlideChange() {

        this.isBeginWhy = this.whySwiperInstance.isBeginning;
        this.isEndWhy = this.whySwiperInstance.isEnd;

    }

    /**
     * Slides to the next image
     */
    gotoWhyNext() {

        this.whySwiperInstance.slideNext();

    }

    /**
     * Slides to the previous image
     */
    gotoWhyPrevious() {

        this.whySwiperInstance.slidePrev();

    }

}
